import moment from "moment";

export const timeStamptoHour = (timestamp) => {
    const updatedAtMoment = moment(timestamp);
    const formattedTime = updatedAtMoment.format('h:mm A');
    return formattedTime;
}